import {Observable} from "rxjs"
import {AjaxResponse} from "rxjs/ajax"

import AuthService from "../../auth/services/AuthService"

// Models
import AuthServiceType from "../../auth/services/AuthServiceType"
import HttpServiceType from "../../http/services/HttpService/HttpServiceType"
import {AnnotationSaveDto} from "../remote"

// Constants
import {RequestMethod} from "../../../constants"

/**
 * The annotation endpoints, keyed by ECG id.
 *
 *     GET record/annotation/{ecgId}   global beats + per-lead reference
 *     PUT record/annotation/{ecgId}   save the corrected beats
 *
 * `record/` is the ingress prefix for the api service, as for the
 * telemedicine endpoints.
 */
const ANNOTATION_PATH = "record/annotation/{id}";

type AnnotationServiceType = {
    fetchAnnotation(ecgId: string): Observable<AjaxResponse>
    saveAnnotation(ecgId: string, annotation: AnnotationSaveDto): Observable<AjaxResponse>
}

const AnnotationService: AnnotationServiceType & AuthServiceType & HttpServiceType = Object.create(AuthService);

/**
 * @param ecgId
 */
AnnotationService.fetchAnnotation = function fetchAnnotation(ecgId) {
    return this.request(`${this.getApiUrl()}${ANNOTATION_PATH.replace("{id}", encodeURIComponent(ecgId))}`, {
        headers: this.getAuthHeader(),
    })
};

/**
 * @param ecgId
 * @param annotation
 */
AnnotationService.saveAnnotation = function saveAnnotation(ecgId, annotation) {
    return this.request(`${this.getApiUrl()}${ANNOTATION_PATH.replace("{id}", encodeURIComponent(ecgId))}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.PUT,
        body: JSON.stringify(annotation),
    })
};

export default AnnotationService
